/**
 * Convert a string to a URL-safe slug for use in S3 keys and file paths.
 * Lowercases, transliterates common unicode characters, replaces spaces
 * with underscores, and strips remaining unsafe characters.
 *
 * "Interior Electrical Floor Plan" → "interior_electrical_floor_plan"
 * "KA0129H_5_GT_SLP_UV-P00-Förderanlage" → "ka0129h_5_gt_slp_uv-p00-foerderanlage"
 */
export function slugify(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_\-\.]/g, '');
}
